import useCustomTranslation from "@/hooks/useTranslation";
import {
	dateFormat,
	east8ToEast9,
	formatNumberWithCommas,
	handleBrowserUrl,
	partiallyHideHash,
	pxToRem,
	setDataToClipboard,
} from "@/util/common";
import { Image, Skeleton, Space } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import QRCode from "react-qr-code";
import { DownFill } from "antd-mobile-icons";
import SelectorPopup from "@/components/selectorPopup";
import useCommonFormStyles from "@/hooks/useCommonStyles";
import useDeposit from "@/hooks/useDeposit";
import { isEmpty } from "lodash";
import { AppDispatch, RootState } from "@/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { getApiFinancePayOrderItemMethod } from "@/redux/reducers/authSlice";
import CustomEmpty from "@/components/Empty";
import { CoinGamingData, TabType, WalletTabKeys } from "..";
import useRouter from "@/hooks/useRouter";
import CoinGamingPopup from "./CoinGaming";

const DepositModule: React.FC<{
	onChange: (newValue: string, active?: TabType) => void; // 添加 active 参数
}> = ({ onChange }) => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { params: routerParams } = useRouter();
	const { t } = useCustomTranslation();
	const commonFormStyles = useCommonFormStyles();
	const { dataPayOrder } = useSelector((state: RootState) => {
		return state.auth;
	});
	const [coinGamingData, setCoinGamingData] = useState<CoinGamingData>(null);
	const [visiblePopup, setVisiblePopup] = useState(false);
	const {
		visible,
		setVisible,
		payOrder,
		payChannel,
		payChannelData,
		switchPayChannel,
	} = useDeposit(1);

	useEffect(() => {
		const fetchData = () => {
			dispatch(
				getApiFinancePayOrderItemMethod({
					page: 0,
					pageSize: 6,
					itemType: routerParams.type || 1,
				})
			);
		};
		fetchData();
		const interval = setInterval(fetchData, 10000);
		return () => clearInterval(interval);
	}, []);

	const handleCoinGamingState = (data?: any) => {
		if (!isEmpty(data)) {
			const coinGamingData: any = {
				currency: data.usdt.toString(),
				feeRate: data.fee,
				address: data.address,
				orderId: data.orderId,
				time: data.updateTime,
				type: "DepositRecords",
				logo: data.networkLogo,
				network: data.network,
				status: data.status,
				reason: data.reason,
				uri: handleBrowserUrl(data.network, data.transNo),
			};
			setCoinGamingData(coinGamingData);
		}
		setVisiblePopup(true);
	};

	return (
		<div className="router-view">
			<div className={commonFormStyles.formWrap}>
				<div className={commonFormStyles.labelTitle}>
					{t("SelectCurrency")}
				</div>
				<div className={commonFormStyles.inputWrap}>
					{!isEmpty(payChannel) ? (
						<Image
							src={payChannel.currencyLogo}
							className="icon"
							fallback={
								<Image
									src={require("@/assets/images/icons/USDT.png")}
									className="icon"
								/>
							}
						/>
					) : (
						<Skeleton animated className="icon" />
					)}
					{!isEmpty(payChannel) ? (
						<div className={commonFormStyles.selector}>
							<span>{payChannel.currency}</span>
						</div>
					) : (
						<Skeleton animated style={{ height: "80%" }} />
					)}
				</div>

				<div className={commonFormStyles.labelTitle}>
					{t("SelectNetwork")}
				</div>
				<div
					onClick={() => setVisible(true)}
					className={commonFormStyles.inputWrap}
				>
					{!isEmpty(payChannel) ? (
						<Image
							src={payChannel.logo}
							className="icon"
							fallback={
								<Image
									src={require("@/assets/images/icons/TRON.png")}
									className="icon"
								/>
							}
						/>
					) : (
						<Skeleton animated className="icon" />
					)}
					{!isEmpty(payChannel) ? (
						<div className={commonFormStyles.selector}>
							<span>{payChannel.network}</span>
							<DownFill color="#5E71B7" fontSize={10} />
						</div>
					) : (
						<Skeleton animated style={{ height: "80%" }} />
					)}
				</div>

				<dl className={classes.tipsWrap}>
					<dt>
						<Image
							src={require("@/assets/images/icons/wait.png")}
							className="icon"
						/>
						<span>{t("WarnTitle")}</span>
					</dt>
					<dd>{t("WarnContent")}</dd>
				</dl>

				<div className={commonFormStyles.labelTitle}>
					{t("UniqueUSDTDepositAddress")}
				</div>
				<div className={classes.addressWrap}>
					{!isEmpty(payOrder) ? (
						<p>{payOrder.address}</p>
					) : (
						<Skeleton animated style={{ height: pxToRem(52) }} />
					)}
					<div
						onClick={() => {
							setDataToClipboard(
								payOrder?.address ?? "",
								t("CopySuccess")
							);
						}}
						className="btn"
					>
						<Image
							src={require("@/assets/images/icons/copy.png")}
							className="icon"
						/>
						<span>Copy</span>
					</div>
				</div>

				<div className={`${commonFormStyles.labelTitle} warn`}>
					<Image
						src={require("@/assets/images/icons/warn.png")}
						className="icon"
					/>
					{t("WarnAddressCheck")}
				</div>
				<Space justify="center" block>
					{!isEmpty(payOrder) ? (
						<QRCode
							size={256}
							style={{
								width: pxToRem(165),
								height: pxToRem(165),
							}}
							value={payOrder.address}
							viewBox={`0 0 256 256`}
						/>
					) : (
						<Skeleton
							animated
							style={{
								width: pxToRem(165),
								height: pxToRem(165),
							}}
						/>
					)}
				</Space>
			</div>
			<div className={classes.columnTitle}>
				<div className="l">
					<strong>{t("DepositRecords")}</strong>
				</div>
				<div
					onClick={() => {
						onChange(WalletTabKeys.ANIMALS, "DepositRecords");
					}}
					className="more"
				>
					{t("ViewAll")} {">>"}
				</div>
			</div>
			{dataPayOrder.length > 0 ? (
				<ul className={classes.listWrap}>
					{dataPayOrder.map((item: any) => (
						<li
							onClick={() => handleCoinGamingState(item)}
							key={item.id}
						>
							<div className="up">
								<Image
									src={require("@/assets/images/icons/USDT.png")}
									className="icon"
								/>
								<p
									onClick={() => {
										setDataToClipboard(
											item.fromAddress,
											t("CopySuccess")
										);
									}}
								>
									{partiallyHideHash(item.fromAddress)}
								</p>
								<strong>
									{formatNumberWithCommas(+item.usdt)}
								</strong>
							</div>
							<div className="down">
								<span>
									{dateFormat(
										east8ToEast9(item.updateTime).getTime(),
										"YYYY-MM-dd hh:mm:ss"
									)}
								</span>
								<span>
									{item.status === 1
										? t("InAccounting")
										: t("PaymentCompletion")}
								</span>
							</div>
						</li>
					))}
				</ul>
			) : (
				<CustomEmpty />
			)}
			<CoinGamingPopup
				visible={visiblePopup}
				data={coinGamingData}
				onClose={() => setVisiblePopup(false)}
				onSubmit={() => {
					setVisiblePopup(false);
				}}
			/>

			<SelectorPopup
				visible={visible}
				data={payChannelData}
				onClose={() => setVisible(false)}
				onSelect={switchPayChannel}
			/>
		</div>
	);
};

export default DepositModule;

const useStyles = createUseStyles({
	tipsWrap: {
		borderTop: "1px solid #2F3A62",
		padding: {
			top: pxToRem(20),
		},
		fontSize: pxToRem(14),
		fontWeight: 500,
		fontFamily: "Noto Sans SC",
		margin: {
			top: pxToRem(28),
			bottom: pxToRem(16),
		},
		"& dt": {
			display: "flex",
			alignItems: "center",
			color: "#FFFFFF",
			paddingBottom: pxToRem(18),
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(8),
			},
		},
		"& dd": {
			color: "#868FA8",
			lineHeight: pxToRem(22),
		},
	},
	addressWrap: {
		display: "flex",
		alignItems: "center",
		border: "1px solid #4C66C7",
		padding: pxToRem(8),
		borderRadius: pxToRem(8),
		backgroundColor: "#181A22",
		marginBottom: pxToRem(18),
		"& p": {
			flex: 1,
			overflow: "hidden",
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			paddingRight: pxToRem(32),
			wordWrap: "break-word",
		},
		"& .btn": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			width: pxToRem(52),
			height: pxToRem(52),
			color: "#868FA8",
			fontSize: pxToRem(10),
			fontWeight: 500,
			borderRadius: pxToRem(5),
			backgroundColor: "#242E4C",
			"& .icon": {
				width: pxToRem(24),
				height: pxToRem(24),
			},
			"&:active": {
				opacity: 0.8,
			},
		},
	},
	columnTitle: {
		display: "flex",
		justifyContent: "space-between",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			top: pxToRem(15),
			bottom: pxToRem(15),
		},
		"& .l": {
			flex: 1,
			overflow: "hidden",
			display: "flex",
			alignItems: "center",
			"& strong": {
				color: "#FFFFFF",
				fontFamily: "Noto Sans SC",
				fontSize: pxToRem(14),
				fontWeight: 500,
			},
		},
		"& .more": {
			color: "#868FA8",
			fontSize: pxToRem(14),
			fontWeight: 400,
		},
	},

	listWrap: {
		"& li": {
			borderTop: "1px solid #2F3A62",
			padding: {
				top: pxToRem(16),
				left: pxToRem(20),
				right: pxToRem(22),
				bottom: pxToRem(20),
			},
			"& >div": {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
			},
		},
		"& .up": {
			fontWeight: 500,
			marginBottom: pxToRem(3),
			"& .icon": {
				width: pxToRem(24),
				height: pxToRem(24),
				marginRight: pxToRem(3),
			},
			"& p": {
				flex: 1,
				overflow: "hidden",
				color: "#FFFFFF",
				fontSize: pxToRem(14),
			},
			"& strong": {
				color: "#8BFF78",
				fontSize: pxToRem(16),
			},
		},
		"& .down": {
			color: "#868FA8",
			fontWeight: 400,
			fontSize: pxToRem(12),
		},
	},
});
